// extracted by mini-css-extract-plugin
export default {"storybook-root":"styles_storybook-root__gf7Oz","main":"styles_main__lKwmH"};